import { EntityMapLocation, FogFacility } from '@rcp/types';
import { RestSlice } from 'src/redux/rest.slice';
import { localizationService, Resource } from 'src/services';

export const entityMapLocationsSlice = new RestSlice<EntityMapLocation>(
	Resource.EntityMapLocation,
	Resource.EntityMapLocation
);
export const entityMapLocationsSliceReducer = entityMapLocationsSlice.rests.reducer;
